 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		98: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = "text/javascript";
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "templates/" + ({"0":"src/containers/blog/Post.jsx","1":"src/containers/blog/Blog.jsx","2":"src/containers/covidcampaign/CovidMaterialPage.jsx","3":"src/containers/site/landing-pages/ProductOverview.jsx","4":"src/containers/site/PlansAndPricev2.jsx","5":"src/containers/site/NewHomev5.jsx","6":"src/containers/site/landing-pages/MeuMelhorAnov2.jsx","7":"src/containers/materials/Materials.jsx","8":"src/containers/site/PlansAndPricev4.jsx","9":"src/containers/site/Representativev2.jsx","10":"src/containers/blog/Mercoscast.jsx","11":"src/containers/site/NewPartner/NewPartnerv2.jsx","12":"src/containers/site/landing-pages/Retargeting.jsx","13":"src/containers/site/landing-pages/OnlineSellingv2.jsx","14":"src/containers/site/landing-pages/OnlineOrderingv2.jsx","15":"src/containers/site/landing-pages/OnlineCatalogv2.jsx","16":"src/containers/site/landing-pages/CatalogB2bv2.jsx","17":"src/containers/site/landing-pages/SellerPlatformv2.jsx","18":"src/containers/site/landing-pages/SellerControlv2.jsx","19":"src/containers/site/landing-pages/SellerAutomationv2.jsx","20":"src/containers/site/landing-pages/SellerAppv2.jsx","21":"src/containers/site/landing-pages/SellerApplicationv2.jsx","22":"src/containers/site/landing-pages/SalesSystemv2.jsx","23":"src/containers/site/landing-pages/SalesSoftwarev2.jsx","24":"src/containers/site/landing-pages/SalesProgramv2.jsx","25":"src/containers/site/landing-pages/SalesPlatformv2.jsx","26":"src/containers/site/landing-pages/SalesManagerv2.jsx","27":"src/containers/site/landing-pages/SalesAutomationv2.jsx","28":"src/containers/site/landing-pages/SalesAppv2.jsx","29":"src/containers/site/landing-pages/SalesApplicationv2.jsx","30":"src/containers/site/landing-pages/RepresentativeSoftwarev2.jsx","31":"src/containers/site/landing-pages/RepresentativeProgramv2.jsx","32":"src/containers/site/landing-pages/RepresentativeAppv2.jsx","33":"src/containers/site/landing-pages/RepresentationSoftwarev2.jsx","34":"src/containers/site/landing-pages/OrderingManagerv2.jsx","35":"src/containers/site/landing-pages/OrderingManagementv2.jsx","36":"src/containers/site/landing-pages/OrderingControlv2.jsx","37":"src/containers/site/landing-pages/OrderingAppv2.jsx","38":"src/containers/site/landing-pages/IndustrySystem.jsx","39":"src/containers/site/landing-pages/ForeignSalesv2.jsx","40":"src/containers/site/landing-pages/DistributorSystemv2.jsx","41":"src/containers/site/landing-pages/DistributorSoftwarev2.jsx","42":"src/containers/site/landing-pages/DistributorAppv2.jsx","43":"src/containers/site/landing-pages/DistributorApp2v2.jsx","44":"src/containers/site/landing-pages/CommercialApplicationv2.jsx","45":"src/containers/site/landing-pages/OrderingSystemv2.jsx","46":"src/containers/site/landing-pages/OrderingSoftwarev2.jsx","47":"src/containers/site/landing-pages/OrderingSoftware2v2.jsx","48":"src/containers/site/landing-pages/PmaxRepresentantes.jsx","49":"src/containers/marketplace/MarketplaceSearchv2.jsx","50":"src/containers/site/recursos/SistemaDePedidosComIA.jsx","51":"src/containers/site/landing-pages/ConquerMarketsv2.jsx","52":"src/containers/site/Partnersv2.jsx","53":"src/containers/site/landing-pages/SalesForcev2.jsx","54":"src/containers/site/landing-pages/MercosPay.jsx","55":"src/containers/site/landing-pages/PmaxIndustriasDistribuidoras.jsx","56":"src/containers/site/landing-pages/ECommerceRep.jsx","57":"src/containers/site/landing-pages/BlackNovemberRep.jsx","58":"src/containers/site/landing-pages/BlackNovember.jsx","59":"src/containers/site/landing-pages/ECommerceB2bv3.jsx","60":"src/containers/site/Industriesv2.jsx","61":"src/containers/site/PrivacyNotice.jsx","62":"src/containers/site/landing-pages/MeusPedidosv2.jsx","63":"src/containers/marketplace/MarketplacePartnerv2.jsx","64":"src/containers/site/TermsAndConditions.jsx","65":"src/containers/site/landing-pages/B2BMesDaIndustria.jsx","66":"src/containers/site/landing-pages/B2BRep.jsx","67":"src/containers/site/landing-pages/MarceloCaetano.jsx","68":"src/containers/site/landing-pages/Videochamada.jsx","69":"src/containers/covidcampaign/CovidMaterials.jsx","70":"src/containers/site/NewAboutv2.jsx","71":"src/containers/site/landing-pages/EuCommerceTP.jsx","72":"src/containers/site/landing-pages/EuCommerce.jsx","73":"src/containers/site/landing-pages/OfertaConversao.jsx","74":"src/containers/materials/MaterialPagev2.jsx","75":"src/containers/site/landing-pages/kitclientesinativos/CalculadoraResultado.jsx","76":"src/containers/site/landing-pages/ImersaoEmVendas.jsx","77":"src/containers/site/landing-pages/FreeTrialv2.jsx","78":"src/containers/site/landing-pages/kitclientesinativos/KitClientesInativos.jsx","79":"src/containers/site/landing-pages/RemarketingDist.jsx","80":"src/containers/site/landing-pages/RemarketingReps.jsx","81":"src/containers/site/landing-pages/ThankYouPageDemos.jsx","82":"src/containers/404v2.jsx","83":"src/containers/landing-pages-partners/Wk.jsx","84":"src/containers/landing-pages-partners/Questor.jsx","85":"src/containers/landing-pages-partners/Omie.jsx","86":"src/containers/landing-pages-partners/Intelitech.jsx","87":"src/containers/landing-pages-partners/Intelidata.jsx","88":"src/containers/landing-pages-partners/Bling.jsx","89":"src/containers/landing-pages-partners/AlterData.jsx","90":"src/components/TrackAndGo.jsx","91":"src/containers/site/landing-pages/ImersaoEmVendasTP.jsx","92":"src/containers/site/landing-pages/kitclientesinativos/KitClientesInativosTP.jsx","93":"src/containers/site/landing-pages/kitclientesinativos/CalculadoraDeOportunidades.jsx","94":"src/containers/site/landing-pages/BlackNovemberTP.jsx","95":"src/containers/site/landing-pages/BlackNovemberRepTP.jsx","96":"src/components/RedirectToUrl.jsx"}[chunkId]||chunkId) + "." + {"0":"40d2cf6e","1":"7641a6da","2":"21cd273a","3":"7b1617f1","4":"b58049c5","5":"5ef4b108","6":"fa076a1d","7":"25be1c24","8":"5952311c","9":"b5dccc40","10":"4acb518f","11":"aeb8a6db","12":"22e85297","13":"b3bb9dc7","14":"a15392bf","15":"744e4790","16":"074170c0","17":"913981d5","18":"30406590","19":"dddc8834","20":"9d129f1e","21":"09790da6","22":"fdda6552","23":"2711d226","24":"3e93dda1","25":"840f69bd","26":"0437b64a","27":"338f6e10","28":"9dbc7b4a","29":"18d2d3a9","30":"3fabbb34","31":"86dfca4d","32":"02e7c9b6","33":"38160911","34":"2739d6b8","35":"ca96e936","36":"03e7ff8e","37":"dba5b2f9","38":"f659e8da","39":"e9a28f07","40":"a8d4f52e","41":"c2505dad","42":"ca573aa6","43":"20cd95fb","44":"9be7173f","45":"f56adf22","46":"8681b3d8","47":"387c5631","48":"1a550769","49":"5e95c3f7","50":"a29f5001","51":"8a77960f","52":"c8435834","53":"a7eff425","54":"14955e9f","55":"dc021b98","56":"8001f2bd","57":"8d68ad4f","58":"1dbd730a","59":"e1c811b0","60":"7e528826","61":"7d1359a8","62":"6ab5823d","63":"21f380bf","64":"72f3f508","65":"062b12bd","66":"58c09bdc","67":"123cfcac","68":"d7cd2e17","69":"abd325b6","70":"17a7b173","71":"33b54c77","72":"80c57b66","73":"cd1edf39","74":"db997a03","75":"52dd0d05","76":"b2ad5352","77":"d4fa05c2","78":"3c26c6ec","79":"5b98dbf7","80":"e2cd1b5d","81":"1f44557a","82":"2823831d","83":"c5fcc47e","84":"6beb5aa0","85":"29cd0b7a","86":"a4ceb8b1","87":"e1436d9a","88":"de3eee1b","89":"0d72dbb3","90":"8acbe7e4","91":"7f5e9fa6","92":"201fce07","93":"3a0106dd","94":"83d18c1f","95":"2a489710","96":"9bb0aaf1"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://mercos.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };



// WEBPACK FOOTER //
// webpack/bootstrap b66232e828463493f1e0